import React from 'react';
import {useSendManagerInvite} from '../../../hooks/community';
import {StepRequestCommunity} from '../../../components/Account/RequestCommunity/RequestCommunity';

export const StepRequestCommunityContainer: React.FC = () => {
  const sendEmail = useSendManagerInvite();

  return <StepRequestCommunity sendEmail={sendEmail} />;
};
